import { cn } from "@/lib/utils";

// 2026 redesign: the image logo/house mark was retired in favour of a clean
// text wordmark — "Swip" in the current ink + "Rent" in lime. This single
// component is the ONE place the wordmark is defined, so every usage across
// the app stays identical. It adapts to context:
//   - on LIGHT surfaces (default): "Swip" is ink, "Rent" is deep lime (readable)
//   - on DARK surfaces (pass `onDark`): "Swip" is near-white, "Rent" is bright lime
//
// `SwipRentMark` is kept as a named export for backwards compatibility (it used
// to render the house icon); it now renders the same wordmark.

export function Wordmark({ className = "", onDark = false, size = 18 }) {
  return (
    <span
      className={cn("inline-flex items-baseline font-extrabold tracking-tight", className)}
      style={{ fontSize: size, letterSpacing: "-0.02em" }}
    >
      <span className={onDark ? "text-night-text" : "text-brand-ink"}>Swip</span>
      <span className={onDark ? "text-brand-primary" : "text-brand-lime"}>Rent</span>
    </span>
  );
}

// Back-compat: previously the small house icon. Now the wordmark.
export function SwipRentMark({ size = 20, onDark = false, className = "" }) {
  return <Wordmark size={size} onDark={onDark} className={className} />;
}

export default function LogoSwipRent({ className = "", compact = false, onDark = false }) {
  return <Wordmark size={compact ? 18 : 22} onDark={onDark} className={className} />;
}
